import { useAmazonBookSearchWithNavigation as useOriginalHook } from '../../scan-books/hooks/useAmazonBookSearchWithNavigation'

export const useAmazonBookSearchWithNavigation = useOriginalHook
